import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useSalesPersonSearch } from 'modules/transactions/new-sales-entry/services/use-sales-entry.service';
import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

interface SalesPersonData {
  id: string;
  name: string;
}

interface SalesPersonModalProps {
  show: boolean;
  onHide: () => void;
  currentSalesPerson: SalesPersonData | null;
  onSalesPersonSelect: (salesPerson: SalesPersonData | null) => void;
}

interface FormErrors {
  salesPerson?: string;
}

export const SalesPersonModal: React.FC<SalesPersonModalProps> = ({
  show,
  onHide,
  currentSalesPerson,
  onSalesPersonSelect
}) => {
  const [selectedSalesPerson, setSelectedSalesPerson] = useState<any>(null);
  const [errors, setErrors] = useState<FormErrors>({});

  const {
    salesPersons,
    loading: salesPersonLoading,
    error: salesPersonError,
    getSalesPersonSelectList
  } = useSalesPersonSearch();

  useEffect(() => {
    if (show) {
      getSalesPersonSelectList();
      setSelectedSalesPerson(null);
    }
    setErrors({});
  }, [show, getSalesPersonSelectList]);

  useEffect(() => {
    if (show && currentSalesPerson && salesPersons.length > 0) {
      const foundSalesPerson = salesPersons.find((sp: any) =>
        sp.value === currentSalesPerson.id || sp.id === currentSalesPerson.id
      );
      setSelectedSalesPerson(foundSalesPerson || null);
    }
  }, [show, currentSalesPerson, salesPersons]);

  const handleClose = () => {
    setSelectedSalesPerson(null);
    setErrors({});
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="sm" dialogClassName="modal-dialog-centered">
      <Modal.Header closeButton>
        <Modal.Title className="text-secondary fw-normal">
          <i className="bx bx-user-check me-2"></i>
          Select Sales Person
          {/* {currentSalesPerson ? 'Update Sales Person' : 'Select Sales Person'} */}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* {currentSalesPerson && (
          <div className="alert alert-info mb-3">
            <i className="bx bx-info-circle me-2"></i>
            Current sales person: <strong>{currentSalesPerson.name}</strong>
          </div>
        )} */}

        <Form>
          <Autocomplete
            disablePortal
            options={salesPersons as any}
            value={selectedSalesPerson}
            onChange={(_, newValue) => {
              if (!newValue) {
                // User clicked "X" to clear
                onSalesPersonSelect(null);
                toast.info('Sales person removed from sales entry', {
                  position: 'top-right',
                  autoClose: 2000,
                });
                handleClose();
                return;
              }

              const salesPersonData: SalesPersonData = {
                id: newValue.value || newValue.id,
                name: newValue.text || newValue.name || '[No Name]'
              };

              onSalesPersonSelect(salesPersonData);

              toast.success(`Sales person ${salesPersonData.name} selected successfully!`, {
                position: "top-right",
                autoClose: 3000,
              });

              handleClose();
            }}
            getOptionLabel={(option) => {
              if (typeof option === 'string') return option;
              return option?.text || option?.name || '[No Name]';
            }}
            renderOption={(props, option) => (
              <li {...props} key={option?.value || option?.id}>
                <div className="d-flex align-items-center w-100">
                  <i className="bx bx-user me-2 text-muted"></i>
                  <div className="flex-grow-1">
                    <div className="fw-medium" style={{ color: '#000' }}>
                      {option?.text || option?.name || '[No Name]'}
                    </div>
                    {option?.department && (
                      <small className="text-muted">{option.department}</small>
                    )}
                  </div>
                </div>
              </li>
            )}
            loading={salesPersonLoading}
            onOpen={() => {
              if (salesPersons.length === 0) {
                getSalesPersonSelectList();
              }
            }}
            // clearOnEscape
            // clearIcon={<i className="bx bx-x text-muted"></i>}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: "0.875rem",
                color: '#000',
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.875rem",
                color: '#000',
              },
              "& .MuiAutocomplete-listbox": {
                fontSize: "0.875rem",
                padding: "4px 0",
              },
              "& .MuiAutocomplete-option": {
                fontSize: "0.875rem",
              },
            }}
            size="small"
            renderInput={(params: any) => (
              <TextField
                {...params}
                label={
                  <>
                    Sales Person
                    {true && <span style={{ color: 'red' }}> *</span>}
                  </>
                }
                size="small"
                error={!!(salesPersonError || errors.salesPerson)}
                helperText={salesPersonError || errors.salesPerson}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {salesPersonLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  },
                }}
              />
            )}
          />

          {/* {selectedSalesPerson && (
            <Card className="bg-light border-0 shadow-sm mt-3">
              <Card.Body className="p-3">
               <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <h6 className="mb-1 text-primary">
                      <i className="bx bx-user me-1"></i>
                      {selectedSalesPerson.text || selectedSalesPerson.name || '[No Name]'}
                    </h6>
                    {selectedSalesPerson.department && (
                      <small className="text-muted">
                        <i className="bx bx-briefcase me-1"></i>
                        {selectedSalesPerson.department}
                      </small>
                    )}
                    {selectedSalesPerson.employeeCode && (
                      <div className="mt-1">
                        <small className="text-muted">
                          <i className="bx bx-id-card me-1"></i>
                          Employee Code: {selectedSalesPerson.employeeCode}
                        </small>
                      </div>
                    )}
                  </div>
                </div> 
              </Card.Body>
            </Card>
          )} */}
        </Form>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end">
        <Button className='btn add-btn' onClick={handleClose} size="sm">
          {/* <i className="bx bx-x me-1"></i> */}
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
